namespace SorAraBul.Common {

    export interface AutofillField {
        element: JQuery;
    }

    export function preventAutofill(fields: AutofillField[]) {
        const disableAutocomplete = (inputs: JQuery) => inputs.attr({
            autocomplete: 'new-password',
            'data-lpignore': 'true',
            'data-1p-ignore': 'true'
        });

        (fields || []).forEach(field => {
            if (!field || !field.element)
                return;

            disableAutocomplete(field.element.add(field.element.closest('.field').find('input')));

            field.element
                .off('select2-open.prevent-autofill')
                .on('select2-open.prevent-autofill', () => {
                    window.setTimeout(() => {
                        disableAutocomplete($('.select2-drop-active').find(
                            'input.select2-input, input.select2-search__field'));
                    }, 0);
                });
        });
    }
}
